module.exports = __webpack_public_path__ + "static/media/mz.a6978aae.svg";